import { createContext } from 'react';

// @ts-expect-error TS2554: Expected 1 arguments, but got 0.
export const FormFocusContext = createContext();
export default FormFocusContext;
